<template>
  <div
    class="credit-card"
  >
    <h2 class="credit-card__title">ACH</h2>
    <div
      class="stripe-card__row stripe-card__row-two-col"
      :class="{ 'input-error': achNameError }"
    >
      <div class="stripe-card__number-row">
        <input
          class="cardknox-ach-fields"
          placeholder="Name"
          v-model="achName"
        />
      </div>
    </div>
    <div class="stripe-card__row stripe-card__row-two-col">
      <div class="stripe-card__number-row">
        <ifields
          ref="ifieldACHRef"
          :type="ACH_TYPE"
          :account=iFieldsOptions
          :options="{
            autoFormat: true,
            autoFormatSeparator: ' ',
            autoSubmit: false,
            placeholder: 'Account Number',
            iFieldstyle: {
              fontSize: '16px',
              backgroundColor: '#EDEDED',
              color: backgroundColor,
              border: 'none',
              outline: 'none',
            }
          }"
        />
      </div>
    </div>
    <div
      class="stripe-card__row stripe-card__row-two-col"
      :class="{ 'input-error': achRoutingError }"
    >
      <div class="stripe-card__number-row">
        <input
          class="cardknox-ach-fields"
          placeholder="Routing Number"
          v-model="achRouting"
        />
      </div>
    </div>
    <div
      :id="'payment-message-' + cardknoxItemID"
      v-if="hasCardError"
      class="form__error credit-card__error"
    >
      <div v-if="errorNumber">
        {{ errorNumber }}
      </div>
    </div>
    <div
      :id="'card-error-' + cardknoxItemID"
      class="form__error credit-card__error"
    />
  </div>
</template>

<script>

import ifields, { ACH_TYPE } from '@cardknox/vue-cardknox-ifields'

export default {
  components: {
    ifields,
  },
  props: {
    iFieldsOptions: {
      type: Object,
      required: true,
    },
    errorNumber: {
      type: String,
      default: '',
    },
    hasCardError: {
      type: Boolean,
      default: false,
    },
    cardknoxItemID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ACH_TYPE,
    }
  },
  computed: {
    backgroundColor() {
      return process.env.SECONDARY_COLOR
    },
    achName: {
      get: function () {
        return this.$store.getters['formValidation/getACHField']('ach_name')
      },
      set: function (val) {
        this.$store.commit('formValidation/setACHFormData', {
          field: 'ach_name',
          value: val,
        })
      }
    },
    achRouting: {
      get: function () {
        return this.$store.getters['formValidation/getACHField']('ach_routing')
      },
      set: function (val) {
        this.$store.commit('formValidation/setACHFormData', {
          field: 'ach_routing',
          value: val,
        })
      }
    },
    achNameError() {
      return this.$store.getters['formValidation/getACHError']('ach_name')
    },
    achRoutingError() {
      return this.$store.getters['formValidation/getACHError']('ach_routing')
    },
  },
  methods: {},
}
</script>


<style lang="scss">
iframe {
  border: 0 solid transparent;
  height: 45px;
  padding: 0px;
  margin-bottom: 5px;
}

</style>
